import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCaretLeft = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 17.0355L9 12.0355L14 7.03546", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "square", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCaretLeft);
const Memo = memo(ForwardRef);
export default Memo;
